/**
 * MESSAGE SUGGESTIONS COMPONENT
 * Shows AI-generated follow-up suggestions
 */

import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface MessageSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

export function MessageSuggestions({ suggestions, onSuggestionClick }: MessageSuggestionsProps) {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-3 space-y-2"
    >
      <div className="text-xs text-slate-400 mb-2">💡 Suggested follow-ups:</div>
      {suggestions.map((suggestion, index) => (
        <motion.button
          key={index}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 }}
          onClick={() => onSuggestionClick(suggestion)}
          className="flex items-center space-x-2 w-full text-left p-2 bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 hover:border-white/20 transition-all group"
        >
          <ArrowRight className="w-3 h-3 text-blue-400 group-hover:text-blue-300 transition-colors" />
          <span className="text-sm text-slate-300 group-hover:text-white transition-colors">
            {suggestion}
          </span>
        </motion.button>
      ))}
    </motion.div>
  );
}